import React from 'react';

import cn from '@/lib/clsxm';

import { Text } from '@/components/@base/typography';

export default function Label({ className, active, children }) {
  return <Text className={cn(active && 'text-[#4e4d4d]', className)}>{children}</Text>;
}
